import { useEffect, useState } from "react";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Form from 'react-bootstrap/Form';

function CreateNewPeriod(props) {
    const {
        handleSubmit,
        fields,
        errors,
        show,
        onHideFunc,
        values,
        isUpdate = false
    } = props;

    const [data, setData] = useState({});
    const [localErrors, setLocalErrors] = useState({});

    useEffect(() => {
        setData(values);
    }, [values]);

    // Update local errors when prop errors change
    useEffect(() => {
        setLocalErrors(errors);
    }, [errors]);

    // Clear errors when component closes
    useEffect(() => {
        if (!show) {
            setLocalErrors({});
        }
    }, [show]);

    const handleChange = (e, field) => {
        const fieldData = { ...data };
        fieldData[field] = e.target.value;
        setData(fieldData);
        
        // Clear the error for this specific field when user starts typing
        if (localErrors[field]) {
            setLocalErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[field];
                return newErrors;
            });
        }
    };

    return (
        <Offcanvas show={show} onHide={onHideFunc} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    {!isUpdate ? 'Create Period' : 'Update Period'}
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div style={{ minHeight: "400px" }}>
                    <div className="sign-user_card">
                        <Form className="login-content" onSubmit={(e) => handleSubmit(e, isUpdate)}>
                            <div className="row">
                                {!!fields && (
                                    Object.keys(fields).map((field) => (
                                        <div className="col-lg-12" key={field}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fields[field]['label']}</Form.Label>
                                                <Form.Control
                                                    name={fields[field]['name']}
                                                    type={fields[field]['type']}
                                                    placeholder={fields[field]['placeholder']}
                                                    value={data[field] ? data[field] : ''}
                                                    onChange={(e) => handleChange(e, field)}
                                                    isInvalid={!!localErrors[field]}
                                                    maxLength={100}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {localErrors[field]}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                    ))
                                )}
                            </div>
                            <div className="text-end mt-3">
                                <button type="submit" className="btn btn-primary">
                                    {!isUpdate ? 'Create' : 'Update'} &raquo;
                                </button>
                            </div>
                        </Form>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default CreateNewPeriod;